import "bootstrap/dist/css/bootstrap.min.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "react-phone-input-2/lib/style.css";
import "react-datepicker/dist/react-datepicker.css";
import "react-loading-skeleton/dist/skeleton.css";
import "react-loading-skeleton/dist/skeleton.css";
import "./App.scss";
import { BrowserRouter, HashRouter } from "react-router-dom";
import Routing from "./routing/Routing";
import { AxiosInterceptor } from "./config/AxiosInstance";
import { Provider } from "react-redux";
import appStore from "./store/appStore";
import "./AppResponsive.css";
import "./style.scss";
import "yet-another-react-lightbox/styles.css";

function App() {
  return (
    <div className="App">
      <BrowserRouter basename="/">
        <Provider store={appStore}>
          <AxiosInterceptor>
            <Routing />
          </AxiosInterceptor>
        </Provider>
      </BrowserRouter>
    </div>
  );
}

export default App;
